// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"2b5c62fb","453":"906b0208","461":"1926e9ac","490":"1e475bcb","883":"dd8980d3","934":"043dd383"}[chunkId] + ".chunk.js";
};